import { Avatar, AvatarProps } from '@mantine/core';
import React from 'react';

import { DeviceModelIcon, DeviceModelIconProps } from './device-model-icon';

interface DeviceAvatarProps extends AvatarProps {
  img?: string;
  icon?: DeviceModelIconProps['iconName'];
}

export function DeviceAvatar({ img, icon, ...avatarProps }: DeviceAvatarProps) {
  return (
    <Avatar radius="sm" src={img} {...avatarProps}>
      <DeviceModelIcon iconName={icon} />
    </Avatar>
  );
}
